import { ref, computed } from 'vue'
import { VENUE_PLANS } from '@/constants/subscriptions'

const subscriptionIntervals = ref([
    {
        name: 'Monthly',
        interval: 'month',
        selected: false
    },
    {
        name: 'Annually',
        interval: 'year',
        selected: false
    }
])
export function useBillingCycles() {
    const DEFAULT_CYCLE = 'year'

    const selectedCycle = computed(() => subscriptionIntervals.value.find((cycle) => cycle.selected))
    const monthPrice = computed(() => {
        return (planName) => {
            const plan = VENUE_PLANS.find((plan) => plan.name === planName)

            return plan.price['month']
        }
    })
    const yearPrice = computed(() => {
        return (planName) => {
            const plan = VENUE_PLANS.find((plan) => plan.name === planName)

            return plan.price['year']
        }
    })
    const monthTotalPrice = computed(() => {
        return (planName) => {
            const plan = VENUE_PLANS.find((plan) => plan.name === planName)

            return plan.price['month'] * 12
        }
    })
    const yearTotalPrice = computed(() => {
        return (planName) => {
            const plan = VENUE_PLANS.find((plan) => plan.name === planName)

            return plan.price['year'] * 12
        }
    })

    ;(() => {
        selectBillingCycle(DEFAULT_CYCLE)
    })()

    function selectBillingCycle(interval) {
        const selectedCycle = subscriptionIntervals.value.find((cycle) => cycle.interval === interval)
        const unselectCycle = subscriptionIntervals.value.filter((cycle) => cycle.interval !== interval)

        selectedCycle.selected = true
        unselectCycle.forEach((cycle) => (cycle.selected = false))
    }

    return {
        subscriptionIntervals,
        selectedCycle,
        monthPrice,
        monthTotalPrice,
        yearPrice,
        yearTotalPrice,
        selectBillingCycle
    }
}
